import Nav from "../Components/Nav/Nav";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const products = [
  {
    name: "AI Humanity",
    tagline: "The Relationship Layer for AI",
    description:
      "Real-time emotion models and voice SDKs that let games, companions, assistants, and robots understand and adapt to how people actually feel — not just what they say.",
    bullets: ["Emotion Models", "Realtime Voice", "Game Voice SDK", "SDK & Platform"],
    url: "https://aihumanity.io",
    cta: "Visit AIHumanity.io",
  },
  {
    name: "FromSource",
    tagline: "One Idea, Every Platform, In Your Voice",
    description:
      "Turns a single idea into publish-ready posts for 11 social platforms — draft, style, humanize, and variants, all from a style engine that learns your actual voice.",
    bullets: ["Social Media Publishing", "Style Engine", "Mac, iPhone & iPad"],
    url: "https://fromsource.io",
    cta: "Visit FromSource.io",
  },
  {
    name: "Tale2Reel",
    tagline: "Visualize Your Story",
    description:
      "From a single idea to a finished short drama — multiple AI agents handle the script, cast, storyboard, video, and voice, with full creative control at every step.",
    bullets: ["AI Video Generation", "AI-Powered Short Drama"],
    url: "https://tale2reel.com",
    cta: "Visit Tale2Reel.com",
  },
];

const Products = () => {
  const theme = createTheme({
    palette: {
      mode: 'dark',
    }
  });

  return (
    <>
      <Nav />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Container maxWidth="lg" sx={{ marginTop: 5, marginBottom: 10 }}>
          <Typography variant="h3" gutterBottom>
            Our Products
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ marginBottom: 6 }}>
            Creata AI started as an AI art app. It's grown into a family of AI products —
            here's the rest of the lineup.
          </Typography>
          <Grid container spacing={4}>
            {products.map((product) => (
              <Grid item xs={12} md={4} key={product.name}>
                <Box
                  sx={{
                    border: '1px solid rgba(255,255,255,0.15)',
                    borderRadius: 2,
                    padding: 3,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Typography variant="h5" gutterBottom>{product.name}</Typography>
                  <Typography variant="subtitle1" color="#33eaff" gutterBottom>{product.tagline}</Typography>
                  <Typography variant="body1" sx={{ marginBottom: 2, flexGrow: 1 }}>
                    {product.description}
                  </Typography>
                  <Box component="ul" sx={{ paddingLeft: 3, marginBottom: 3 }}>
                    {product.bullets.map((bullet) => (
                      <li key={bullet}><Typography variant="body2">{bullet}</Typography></li>
                    ))}
                  </Box>
                  <Button
                    variant="contained"
                    href={product.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {product.cta}
                  </Button>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </ThemeProvider>
    </>
  );
}

export default Products;
